// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"styles_menuItem__1d4y1"};